import React from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';

/**
 * DateInput
 *
 * Uses react-datetime's custom calendar popup — navigating months never fires
 * onChange, only clicking a specific day does. This eliminates the browser's
 * native auto-select-on-month-navigation behaviour entirely.
 *
 * The picker is position:absolute within the .rdt wrapper so it scrolls
 * naturally with the rest of the panel content.
 *
 * Props:
 *   value       {string}   YYYY-MM-DD string (or '') for the committed date
 *   onChange    {function} called with YYYY-MM-DD string, or null to clear
 *   className   {string}   applied to the underlying <input>
 *   min         {string}   YYYY-MM-DD — dates before this are disabled
 *   placeholder {string}   input placeholder (default 'MM/DD/YYYY')
 */
function DateInput({ value, onChange, className, min, placeholder }) {
	const isValidDate = min
		? (current) => current.isSameOrAfter(moment(min, 'YYYY-MM-DD'), 'day')
		: undefined;

	return (
		<Datetime
			value={value ? moment(value, 'YYYY-MM-DD') : ''}
			dateFormat="MM/DD/YYYY"
			timeFormat={false}
			closeOnSelect
			onChange={(date) => {
				if (moment.isMoment(date) && date.isValid()) {
					onChange(date.format('YYYY-MM-DD'));
				} else if (date === '' || date === null || date === undefined) {
					onChange(null);
				}
			}}
			inputProps={{
				className,
				placeholder: placeholder || 'MM/DD/YYYY',
				readOnly: true,
			}}
			isValidDate={isValidDate}
		/>
	);
}

export default DateInput;
